import { BasicInfoFields } from 'clickNgo/entities/partner/configs'

export const PARTNER_BASIC_INFO_EDITABLE_FIELDS = [
  BasicInfoFields.CommunicationName,
  BasicInfoFields.Email,
  BasicInfoFields.TaxId,
  BasicInfoFields.Url,
  BasicInfoFields.Phone,
  BasicInfoFields.PhoneCountryCode,
  BasicInfoFields.StoreNumber,
  BasicInfoFields.AddressLine1,
  BasicInfoFields.AddressLine2,
  BasicInfoFields.AddressLine3,
  BasicInfoFields.Country,
  BasicInfoFields.State,
  BasicInfoFields.City,
  BasicInfoFields.ZipCode,
]
